<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<span class="badge" [ngClass]="classLabel">
  {{ displayLabel }}
  @if (isDraft && isPublished ) {
  <fa-icon [icon]="publishedDraftIcon"></fa-icon>
  }
</span>
